export default "__VITE_ASSET__optPzAoH__"